import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent implements OnInit {
  activeTabSetting = "availability";
  activeTabNav = "serviceAccessCity";

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Read query parameters from URL
    this.route.queryParams.subscribe((params) => {
      const tabParam = params["tab"];
      const navParam = params["nav"];

      if (tabParam) {
        // Validate tab parameter
        if (["availability", "marketing", "token"].includes(tabParam)) {
          this.activeTabSetting = tabParam;

          // Set default nav based on tab if nav is not provided
          if (!navParam) {
            if (tabParam === "availability") {
              this.activeTabNav = "serviceAccessCity";
            } else if (tabParam === "marketing") {
              this.activeTabNav = "ride";
            } else if (tabParam === "token") {
              this.activeTabNav = "uberToken";
            }
          } else {
            // Validate and set nav parameter
            if (tabParam === "availability") {
              if (["serviceAccessCity", "serviceAccessCountry"].includes(navParam)) {
                this.activeTabNav = navParam;
              } else {
                this.activeTabNav = "serviceAccessCity";
              }
            } else if (tabParam === "marketing") {
              if (["ride", "yacht", "rental"].includes(navParam)) {
                this.activeTabNav = navParam;
              } else {
                this.activeTabNav = "ride";
              }
            } else if (tabParam === "token") {
              this.activeTabNav = "uberToken";
            }
          }
        }
      }
    });
  }

  public changeSetting(activeTabVal: string) {
    this.activeTabSetting = activeTabVal;
    if (activeTabVal === "availability") {
      this.activeTabNav = "serviceAccessCity";
    } else if (activeTabVal === "marketing") {
      this.activeTabNav = "ride";
    } else if (activeTabVal === "token") {
      this.activeTabNav = "uberToken";
    }

    // Update URL with query parameters
    this.router.navigate([], {
      queryParams: { tab: activeTabVal, nav: this.activeTabNav },
      queryParamsHandling: "merge",
    });
  }

  public changeNav(activeTabVal: string) {
    this.activeTabNav = activeTabVal;

    // Update URL with query parameters
    this.router.navigate([], {
      queryParams: { tab: this.activeTabSetting, nav: activeTabVal },
      queryParamsHandling: "merge",
    });
  }
}
